import { firestore } from "./firebase.config"; 
import { doc, setDoc, updateDoc, getDoc, collection, query, where, getDocs } from "firebase/firestore"; 

/*export const handleUpload = async (data, documentId) => {
    try {
        const docRef = doc(firestore, "Timer", documentId); 

        // Check if the document already exists
        const existingDoc = await getDoc(docRef);
        if (existingDoc.exists()) {
            // Update the existing document with new data
            await updateDoc(docRef, data);
        } else {
            // Set a new document if it doesn't exist
            await setDoc(docRef, data, { merge: true });
        }

        console.log("Data uploaded successfully!");
    } catch (error) {
        console.error("Error uploading data:", error);
    }
};*/


export const handleUpload = async (data, documentId) => {
    try {
        const docRef = doc(firestore, "Timer", documentId); 

        // Check if the document already exists
        const existingDoc = await getDoc(docRef);
        if (existingDoc.exists()) {
            await updateDoc(docRef, data);  // Update if it exists
        } else {
            await setDoc(docRef, data, { merge: true }); // Create if it doesn't exist
        }

        console.log("Data uploaded successfully to Timer collection!");
    } catch (error) {
        console.error("Error uploading data to Timer:", error);
        throw error;
    }
};

// New function to check for active timers
export const checkActiveTimer = async (userEmail) => {
    try {
        const userTimerRef = doc(firestore, "UserTimers", userEmail);
        const userTimerDoc = await getDoc(userTimerRef);
        
        if (userTimerDoc.exists() && userTimerDoc.data().isRunning) {
            return true;
        }
        return false;
    } catch (error) {
        console.error("Error checking active timer:", error);
        throw error;
    }
};

// New function to get timer history
export const getTimerHistory = async (userEmail) => {
    try {
        const timerQuery = query(
            collection(firestore, "Timer"),
            where("userEmail", "==", userEmail)
        );
        
        const querySnapshot = await getDocs(timerQuery);
        const timerHistory = [];
        
        querySnapshot.forEach((doc) => {
            timerHistory.push({
                id: doc.id,
                ...doc.data()
            });
        });
        
        return timerHistory;
    } catch (error) {
        console.error("Error fetching timer history:", error);
        throw error;
    }
};
